import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import unsplash from "../api/unsplash";
import { useLocation, useNavigate } from "react-router-dom";

import {
  DataGridPro,
  GridToolbar,
  itIT,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from "../utils/PersistedDataGridPro";
import { CustomFooterPersonalized } from "../utils/CustomFooterPersonalized";
import {
  buildAccertamentiVisitaRows,
  getAccertamentiVisitaBackupSelection,
  getAccertamentiVisitaSelectionChanges,
  getAccertamentiVisitaRowId,
  getAccertamentiVisitaSelectedRows,
  getAccertamentiVisitaSelectionRowIds,
  markProtocolloSanitarioPacchetti,
  renderAccertamentoVisitaCell,
} from "../utils/accertamentiVisitaRows";
import GlobalSnackbar from "./Snackbar";
import Allegati from "./Allegati";
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import moment from "moment";
import momentTimezone from "moment-timezone";
import "moment/locale/it";
import {
  LocalizationProvider,
  DatePicker,
  PickersDay,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment as DateAdapter } from "@mui/x-date-pickers/AdapterMoment";
import {
  Add,
  HealthAndSafety,
  WarningOutlined,
  Delete,
  HourglassBottom,
  HourglassDisabled,
  Error,
  ErrorOutline,
  CheckCircle,
  MenuBook,
  Close,
  Check,
  ArrowForward,
  DoneAll,
  PersonOff,
  Person,
  History,
  CheckBox,
  InsertDriveFile,
  Flight,
} from "@mui/icons-material";
import {
  LinearProgress,
  ButtonGroup,
  OutlinedInput,
  FormHelperText,
  FormControlLabel,
  Checkbox,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Popover,
  DialogActions,
  Box,
  Typography,
  Step,
  StepLabel,
  Stepper,
  CircularProgress,
  Tooltip,
  Backdrop,
  Card,
  CardContent,
  Zoom,
  Chip,
  ListItemText,
} from "@mui/material";
import DettaglioLavoratore from "./DettaglioLavoratore/DettaglioLavoratore";
import { getStatoScadenzaAccertamento } from "../utils/scadenzeAccertamenti";
import {
  appartieneAUtenteMedicina,
  scadenzaMedicinaVisibile,
} from "../utils/filtroScadenzeMedicina";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const ScadenzarioVisite = () => {
  const [skip, setSkip] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [visite] = useState([]);
  const [visisteBackup, setVisiteBackup] = useState([]);
  const [tipologiaVisita, setTipologiaVisita] = useState();
  const [filtro] = useState({
    verde: true,
    arancione: true,
    rosso: true,
    viola: true,
  });
  const [accertamenti, setAccertamenti] = useState([]);
  const [accertamentiSel, setAccertamentiSel] = useState([]);
  const [mostraTutto, setMostraTutto] = useState(false);
  const [soloMiei, setSoloMiei] = useState(false);
  const [filtroDate, setFiltroDate] = useState(() => ({
    dal: moment().format("YYYY-MM-DD"),
    al: moment().add(1, "year").format("YYYY-MM-DD"),
  }));
  const [lavoratore, setLavoratore] = useState(0);
  const [lavoratoriSel, setLavoratoriSel] = useState([]);
  const [medici, setMedici] = useState();
  const [esiti, setEsiti] = useState();
  const [loading, setLoading] = useState(true);
  const [filtroEtichette, setFiltroEtichette] = useState({
    Medico: "",
    Lavoratore: "",
    Blocco: "",
    Cliente: "",
  });

  const [filtroClessidera, setFiltroClessidera] = useState({
    verde: true,
    arancione: true,
    rosso: true,
    alert: true,
    attivi: true,
    passivi: false,
  });

  const scadenze = useMemo(() => {
    const oggi = moment().format("YYYY-MM-DD");
    const utente = sessionStorage.getItem("idUsername");
    return visisteBackup.filter((v) => {
      if (soloMiei && !appartieneAUtenteMedicina(v, utente)) return false;
      if (
        !scadenzaMedicinaVisibile(
          v.Scadenza,
          filtroDate.dal,
          filtroDate.al,
          mostraTutto,
        )
      )
        return false;
      const attivo =
        !v.DataTermine || moment(v.DataTermine).format("YYYY-MM-DD") > oggi;
      if (attivo ? !filtroClessidera.attivi : !filtroClessidera.passivi)
        return false;
      if (!filtroClessidera.alert && (v.Esito === 3 || v.Esito === 4))
        return false;
      if (v.DataUltimaVisita) {
        const colore =
          v.Esito > 1
            ? "verde"
            : moment(v.DataUltimaVisita).format("YYYY-MM-DD") < oggi
              ? "rosso"
              : "arancione";
        if (!filtroClessidera[colore]) return false;
      }
      if (
        accertamentiSel.length &&
        !v.Accertamenti.some((a) => accertamentiSel.includes(a.Accertamento))
      )
        return false;
      return true;
    });
  }, [
    visisteBackup,
    filtroClessidera,
    accertamentiSel,
    filtroDate,
    mostraTutto,
    soloMiei,
  ]);

  const columns = [
    {
      filterable: false,
      field: "Actions",
      headerName: "Azioni",
      headerAlign: "center",
      hide: false,
      width: "100",
      align: "center",
      renderCell: (
        params, //mi aiuta a mettere il valore
      ) => (
        <ButtonGroup>
          <DettaglioLavoratore
            lavoratore={params.row}
            cliente={params.row.Cliente}
            loadLavoratori={loadLavoratori}
          />
        </ButtonGroup>
      ),
    },

    /*     {
      filterable: false,
      field: "StatoVisita",
      headerName: "Stato",
      width: 20,
      renderCell: (
        params //mi aiuta a mettere il valore
      ) => (
        <div>
          {params.row.StatoVisita === "OK" ? (
            <CheckCircle sx={{ color: "#40C18F" }} />
          ) : (
            <Error
              sx={{
                color:
                  params.row.StatoVisita === "InScadenza"
                    ? "#FFC897"
                    : params.row.StatoVisita === "Parziale"
                    ? "#2265B1"
                    : "#FF2768",
              }}
            />
          )}
        </div>
      ),
    }, */
    {
      field: "D",
      headerName: "Info",
      width: 120,

      renderCell: (
        params, //mi aiuta a mettere il valore
      ) => (
        <div>
          {params.row.StatoVisita === "OK" ? (
            <CheckCircle sx={{ color: "#40C18F" }} />
          ) : (
            <Error
              sx={{
                color:
                  params.row.StatoVisita === "InScadenza"
                    ? "#FFC897"
                    : params.row.StatoVisita === "Parziale"
                      ? "#2265B1"
                      : "#FF2768",
              }}
            />
          )}
          {!params.row.DataTermine ||
          moment(params.row.DataTermine).format("YYYY-MM-DD") >
            moment(new Date()).format("YYYY-MM-DD") ? (
            <Tooltip title="Attivo">
              <Person sx={{ color: "#40C18F", marginRight: "3px" }} />
            </Tooltip>
          ) : (
            <Tooltip title="Cessato">
              <PersonOff sx={{ color: "#FF2768", marginRight: "3px" }} />
            </Tooltip>
          )}
          {params.row.RagioneSocialeDa ? (
            <Tooltip title={"Distaccato da " + params.row.RagioneSocialeDa}>
              <Flight
                className="hover:cursor-pointer"
                sx={{ rotate: "135deg", color: "#9059C3" }}
              />
            </Tooltip>
          ) : (
            ""
          )}
          {params.row.DataUltimaVisita === null ? (
            ""
          ) : /*1*/ moment(params.row.DataUltimaVisita).format("YYYY-MM-DD") <
              moment(new Date()).format("YYYY-MM-DD") &&
            params.row.Esito <= 1 ? (
            <HourglassBottom sx={{ color: "#FF2768" }} />
          ) : params.row.Esito > 1 ? (
            <HourglassBottom sx={{ color: "#40C18F" }} />
          ) : (
            <HourglassBottom sx={{ color: "#FFC897" }} />
          )}
        </div>
      ),
      ///<Flight  sx={{rotate:"135deg",, color: "#9059C3"}}/>
    },
    /*     {
      filterable: false,
      field: "Visita",
      headerName: "*",
      width: 10,
      renderCell: (
        params //mi aiuta a mettere il valore
      ) => (
        <div>
          {params.row.DataUltimaVisita === null ? (
            ""
          ) : moment(params.row.DataUltimaVisita).format("YYYY-MM-DD") <
              moment(new Date()).format("YYYY-MM-DD") &&
            params.row.Esito <= 1 ? (
            <HourglassBottom sx={{ color: "#FF2768" }} />
          ) : params.row.Esito > 1 ? (
            <HourglassBottom sx={{ color: "#40C18F" }} />
          ) : (
            <HourglassBottom sx={{ color: "#FFC897" }} />
          )}
        </div>
      ),
    }, */

    {
      field: "Scadenza",
      headerName: "Scadenza",
      width: 150,
      //flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
      renderCell: (params) => {
        return (
          <div>
            {params.row.Scadenza
              ? moment(params.row.Scadenza).format("DD - MM - YYYY")
              : ""}
          </div>
        );
      },
    },
    {
      field: "**",
      headerName: "Accertamenti",
      width: 300,

      headerAlign: "center",
      align: "center",
      sort: "asc",
      renderCell: (params) => {
        return (
          <div>
            {params.row.Accertamenti.map((c, index) => {
              let colore = "",
                testo = "";
              let show = true;
              if (c.AccertamentoMancante === 1) {
                colore = "#8E75AC";
                testo = "Corso Base mancante";
                if (filtro.viola === true) {
                  show = true;
                } else {
                  show = false;
                }
              } else {
                const statoScadenza = getStatoScadenzaAccertamento(c.Scadenza);
                colore = statoScadenza.colore;
                testo = statoScadenza.testo;
                show = filtro[statoScadenza.filtro] === true;
              }
              let showCorso = true;
              if (
                accertamentiSel.length > 0 &&
                !accertamentiSel.includes(c.Accertamento)
              ) {
                showCorso = false;
              }
              if (show && showCorso) {
                // if (show ) {
                return (
                  <Tooltip
                    key={`${params.row.ID}-${c.Accertamento ?? "acc"}-${index}`}
                    title={testo}
                  >
                    <Chip
                      label={c.Accertamento}
                      size="small"
                      sx={{
                        display: c.Accertamento ? "" : "None",
                        marginLeft: "2px",
                        backgroundColor:
                          c.AccertamentoMancante === 0 &&
                          c.Scadenza !== "" &&
                          filtro.blue
                            ? "#11526f"
                            : colore,
                        color: "white",
                      }}
                    />
                  </Tooltip>
                );
              }
            })}
          </div>
        );
      },
    },

    {
      field: "RagioneSociale",
      headerName: "Cliente",
      width: 200,
      //flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "SedeBlocco",
      headerName: "Blocco",
      width: 200,
      //flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "Referente",
      headerName: "Referente",
      width: 200,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "Cognome",
      headerName: "Cognome",
      width: 200,
      //flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "Nome",
      headerName: "Nome",
      width: 200,
      //flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "Descrizione",
      headerName: "Mansione",
      width: 200,
      //flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "Note",
      headerName: "Note",
      width: 200,
      //flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "Gruppo",
      headerName: "Gruppo",
      width: 180,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "Distaccato",
      width: 200,
      //flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "SedeDesc",
      headerName: "Sede",
      width: 200,
      //flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "Categoria",
      headerName: "Categoria",
      width: 200,
      //flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "LimPassate",
      headerName: "Limitazioni",
      width: 200,
      //flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "NomeMedico",
      headerName: "Medico",
      width: 200,
      //flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "username",
      headerName: "Utente",
      width: 200,
      //flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
  ];

  const filterClessidera = (e, colore) => {
    const checked = e.target.checked;
    setFiltroClessidera((current) => ({ ...current, [colore]: checked }));
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <GridToolbarQuickFilter placeholder="Cerca..." />
          <Button
            variant="text"
            size="small"
            startIcon={<InsertDriveFile />}
            onClick={() =>
              document.getElementById("printDocScadenzario").click()
            }
          >
            Scarica Excel
          </Button>
          <FormControl sx={{ m: 1, width: 200 }} size="small">
            <InputLabel id="demo-multiple-checkbox-label" size="small">
              Accertamenti
            </InputLabel>
            <Select
              size="small"
              label="Accertamenti"
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              multiple
              value={accertamentiSel}
              onChange={handleChangeCorsiSel}
              input={<OutlinedInput label="Tag" />}
              renderValue={(selected) => selected.join(", ")}
            >
              {accertamenti.map((c, index) => (
                <MenuItem
                  key={`${c.Codice ?? c.Descrizione ?? "acc"}-${index}`}
                  value={c.Descrizione}
                >
                  <Checkbox
                    checked={accertamentiSel.indexOf(c.Descrizione) > -1}
                  />
                  <ListItemText primary={c.Descrizione} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {[
            ["rosso", "Visita senza esito, data passata", "#FF2768"],
            [
              "arancione",
              "Visita senza esito, data odierna o futura",
              "#FFC897",
            ],
            ["verde", "Visita con esito", "#40C18F"],
          ].map(([colore, label, color]) => (
            <Tooltip title={label} key={colore}>
              <Checkbox
                icon={<HourglassDisabled />}
                checkedIcon={<HourglassBottom />}
                checked={filtroClessidera[colore]}
                onChange={(e) => filterClessidera(e, colore)}
                inputProps={{ "aria-label": label }}
                sx={{ color: `${color}!important` }}
              />
            </Tooltip>
          ))}
          <Tooltip title="Esiti con alert">
            <Checkbox
              icon={<ErrorOutline />}
              checkedIcon={<Error />}
              checked={filtroClessidera.alert}
              onChange={(e) => filterClessidera(e, "alert")}
              inputProps={{ "aria-label": "Esiti con alert" }}
              sx={{ color: "#FFC897!important" }}
            />
          </Tooltip>
          <FormControlLabel
            control={
              <Checkbox
                checked={mostraTutto}
                onChange={(e) => setMostraTutto(e.target.checked)}
              />
            }
            label="Mostra tutto"
          />
          <FormControlLabel
            sx={{ marginBottom: "0px!important" }}
            control={
              <Checkbox
                checked={filtroClessidera.attivi}
                onClick={(e) => filterClessidera(e, "attivi")}
              />
            }
            label="Attivi"
          />
          <FormControlLabel
            sx={{ marginBottom: "0px!important" }}
            control={
              <Checkbox
                checked={filtroClessidera.passivi}
                onClick={(e) => filterClessidera(e, "passivi")}
              />
            }
            label="Passivi"
          />
          <Button
            variant={soloMiei ? "contained" : "outlined"}
            aria-pressed={soloMiei}
            onClick={() => setSoloMiei((current) => !current)}
            sx={{
              mr: 1,
              ...(soloMiei && { "&&": { color: "#fff !important" } }),
            }}
          >
            Solo miei
          </Button>
          <Box
            sx={{
              display: "flex",
              columnGap: 1.5,
              rowGap: 1,
              alignItems: "center",
              flexWrap: "wrap",
              ml: 0,
              mb: 0,
              px: 1.5,
              py: 0.5,
              border: "1px solid #dce7eb",
              borderRadius: 2,
              backgroundColor: "#f7fafb",
            }}
          >
            <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
              {[
                ["dal", "Dal"],
                ["al", "Al"],
              ].map(([field, label]) => (
                <TextField
                  key={field}
                  label={label}
                  type="date"
                  size="small"
                  sx={{
                    width: 145,
                    backgroundColor: "#fff",
                    borderRadius: 1,
                  }}
                  value={filtroDate[field]}
                  disabled={mostraTutto || loading}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    setFiltroDate((current) => ({
                      ...current,
                      [field]: e.target.value,
                    }));
                  }}
                />
              ))}
            </Box>
          </Box>
        </Grid>
      </GridToolbarContainer>
    );
  }

  const massiveVisit = (e) => {
    if (lavoratoriSel.length > 0) {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      setSkip(false);
      document.getElementById("myDialog").click();
    } else {
      //se vuoto mostro l'alert
      setAnchorEl(e.currentTarget);
    }
  };

  const loadLavoratori = async () => {
    try {
      let responseScadenzario = await unsplash.get("lavoratori", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        params: { scandenziario: "SI" },
      });

      setVisiteBackup(responseScadenzario.data.data);
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    // è un loop qui carico i dati
    const fetchData = async () => {
      try {
        let response = await unsplash.get("anagraficaAccertamenti", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        });

        setAccertamenti(response.data.data);
        let responseScadenzario = await unsplash.get("lavoratori", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
          params: { scandenziario: "SI" },
        });
        setLoading(false);
        setVisiteBackup(responseScadenzario.data.data);

        let responseEsiti = await unsplash.get("esiti", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        });
        setEsiti(responseEsiti.data.data);

        let responseTipologiaVisita = await unsplash.get("tipologiaVisita", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        });
        setTipologiaVisita(responseTipologiaVisita.data.data);
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchData();
  }, []);

  const handleChangeCorsiSel = (event) => {
    setAccertamentiSel(event.target.value);
  };

  return (
    <>
      {" "}
      {/*<GlobalSnackbar severity={snack.severity} messaggio={snack.messaggio} openSnack={openSnack} handleCloseSnack={handleCloseSnack}/>*/}
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <div>
              {visite === undefined ? (
                <p>
                  {" "}
                  <center>
                    <CircularProgress />
                  </center>
                </p>
              ) : (
                <>
                  <Grid
                    container
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    {/* <Grid item xs={2}>
                      <TextField
                        size="small"
                        label="Lavoratore"
                        fullWidth
                        onChange={(e) => {
                          filtraTutto(e, "Lavoratore");
                          let f = { ...filtroEtichette };
                          f.Lavoratore = e.target.value;
                          setFiltroEtichette(f);
                        }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        size="small"
                        label="Medico"
                        sx={{ marginRight: "10px" }}
                        fullWidth
                        onChange={(e) => {
                          filtraTutto(e, "Medico");
                        }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        size="small"
                        label="Cliente"
                        sx={{ marginRight: "10px" }}
                        fullWidth
                        onChange={(e) => {
                          filtraTutto(e, "Cliente");
                        }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        size="small"
                        label="Blocco"
                        sx={{ marginRight: "10px" }}
                        fullWidth
                        onChange={(e) => {
                          filtraTutto(e, "Blocco");
                        }}
                      />
                    </Grid> */}
                    <Grid item xs={2}>
                      <Button
                        startIcon={<HealthAndSafety />}
                        onClick={massiveVisit}
                        className="ButtonMiller"
                        style={{
                          color: "white",
                          display: lavoratoriSel.length > 0 ? "" : "None",
                        }}
                      >
                        VISITA MASSIVA
                      </Button>
                    </Grid>
                  </Grid>
                  <MyDialog
                    loadLavoratori={loadLavoratori}
                    lavoratori={lavoratoriSel}
                    medici={medici}
                    esiti={esiti}
                    tipologiaVisita={tipologiaVisita}
                    // cliente={props.idAzienda}
                  />
                  <PopUpCorsi lavoratore={lavoratore} />
                  <Box
                    sx={{
                      height: { xs: "80vh", md: "70vh", xl: "80vh" },
                      width: 1,
                    }}
                  >
                    <DataGridPro
                      sx={{ fontSize: 12 }}
                      components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooterPersonalized,
                      }}
                      slots={{
                        loadingOverlay: LinearProgress,
                      }}
                      loading={loading}
                      initialState={{ pinnedColumns: { left: ["Actions"] } }}
                      localeText={
                        itIT.components.MuiDataGrid.defaultProps.localeText
                      }
                      rows={scadenze}
                      columns={columns}
                      getRowId={(row) => row.ID}
                      pageSize={100}
                      checkboxSelection
                      onSelectionModelChange={(ids) => {
                        const selectedIDs = new Set(ids);
                        const selectedRowData = scadenze.filter((row) =>
                          selectedIDs.has(row.ID),
                        );
                        setLavoratoriSel(selectedRowData);
                      }}
                      onCellClick={(params, e) => {
                        if (params.field === "Actions") {
                          e.stopPropagation();
                        }
                      }}
                    />
                  </Box>
                  <div style={{ display: "None" }}>
                    <ReactHtmlTableToExcel
                      id="printDocScadenzario"
                      className="download-table-xls-button"
                      table="table-to-xls"
                      filename={"Log"}
                      sheet={"Log"}
                      style={{ display: "None!important" }}
                      buttonText="Download Log"
                    />
                  </div>
                  <table
                    id="table-to-xls"
                    style={{ marginTop: 10, display: "None" }}
                    cellSpacing={0}
                    border={0}
                  >
                    <thead>
                      <tr>
                        <th>Scadenza</th>
                        <th>Cliente</th>
                        <th>Cognome</th>
                        <th>Nome</th>
                        <th>Blocco</th>
                        <th>Distacco</th>
                        <th>Categoria</th>
                        <th>Medico</th>
                        <th>Utente</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lavoratoriSel?.map((lav) => (
                        <tr key={lav.ID}>
                          <td>
                            {lav.Scadenza
                              ? moment(lav.Scadenza).format("DD - MM - YYYY")
                              : ""}
                          </td>
                          <td>{lav.RagioneSociale}</td>
                          <td>{lav.Cognome}</td>
                          <td>{lav.Nome}</td>
                          <td>{lav.SedeBlocco}</td>
                          <td>{lav.Distaccato}</td>
                          <td>{lav.Categoria}</td>
                          <td>{lav.NomeMedico}</td>
                          <td>{lav.username}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
            </div>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};

export default ScadenzarioVisite;

const PopUpCorsi = (props) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        aria-label="edit"
        id="allegati"
        onClick={handleClickOpen}
        sx={{ display: "None" }}
      >
        Allegati{" "}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth={"md"}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ paddingTop: "10px", paddingBottom: "10px" }}>
          Allegati
        </DialogTitle>
        <DialogContent sx={{ marginTop: "30px" }}>
          <Allegati
            idLavoratore={props.lavoratore}
            id={props.lavoratore}
            colonna="Lavoratore"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>annulla</Button>
          <Button onClick={() => props.myFunction(props.id)}>Conferma</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const MyDialog = (props) => {
  const getVisiotestMonths = (lavoratore) => {
    const isGavio =
      String(lavoratore?.Categoria || "")
        .trim()
        .toLowerCase() === "gavio";
    if (isGavio) {
      return 24;
    }
    const year = lavoratore?.CF ? ageFromCf(lavoratore.CF) : 0;
    return year > 50 ? 24 : 60;
  };

  const [data, setData] = useState(null);
  const [medicoSel, setMedicoSel] = useState("");
  const [esitoSel, setEsitoSel] = useState("");
  const [tipologiaSel, setTipologiaSel] = useState("");
  const [dataSel, setDataSel] = useState(new Date());
  const [open, setOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [accertamenti, setAccertamenti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [medici, setMedici] = useState([]);
  const [selectionModel, setSelectionModel] = useState([]);
  const [selectionModelBk, setSelectionModelBk] = useState([]);
  const [openScadenzaDialog, setOpenScadenzaDialog] = useState(false);
  const [selectedAccertamento, setSelectedAccertamento] = useState(null);
  const isEditingCellRef = useRef(false);
  const [protocolliLav, setProtocolliLav] = useState([]);

  const [selectedACS, setSelectedACS] = useState([]);
  const [noteSel, setNoteSel] = useState("");
  const [luogoSel, setLuogoSel] = useState("");
  const [required, setRequired] = useState({
    medico: false,
    data: false,
    tipo: false,
  });
  const [openSnack, setOpenSnack] = useState(false);
  const [snack, setSnack] = useState({
    severity: "success",
    messaggio: "Salvataggio Effettuato correttamente",
    open: false,
  });
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  const handleOpenScadenzaDialog = (row) => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    setSelectedAccertamento({
      ...row,
      _ids: row?._ids ?? (row?.ID ? [row.ID] : []),
      Scadenza: row?.Scadenza || moment(dataSel).format("YYYY-MM-DD"),
      Importo: row?.Importo || 0,
      ImportoPassivo: row?.ImportoPassivo || 0,
    });
    requestAnimationFrame(() => {
      setOpenScadenzaDialog(true);
    });
  };

  const handleSaveScadenzaDialog = () => {
    const idsDaAggiornare = new Set(
      (selectedAccertamento?._ids?.length
        ? selectedAccertamento._ids
        : [selectedAccertamento?.ID]
      ).map(String),
    );
    if (idsDaAggiornare.size === 0 || !selectedAccertamento) {
      setOpenScadenzaDialog(false);
      return;
    }

    const nuovaScadenza = selectedAccertamento.Scadenza
      ? moment(selectedAccertamento.Scadenza).format("YYYY-MM-DD")
      : null;
    setAccertamenti((current) =>
      current.map((row) =>
        idsDaAggiornare.has(String(row.ID))
          ? { ...row, Scadenza: nuovaScadenza }
          : row,
      ),
    );
    setSelectionModel((current) =>
      (current || []).map((row) =>
        idsDaAggiornare.has(String(row.ID))
          ? { ...row, Scadenza: nuovaScadenza }
          : row,
      ),
    );
    setSelectionModelBk((current) =>
      (current || []).map((row) =>
        idsDaAggiornare.has(String(row.ID))
          ? { ...row, Scadenza: nuovaScadenza }
          : row,
      ),
    );
    setOpenScadenzaDialog(false);
  };

  const reorderAccertamentiBySelection = (rows = [], selectedRows = []) => {
    const selectedIds = new Set(
      (selectedRows || [])
        .filter((row) => row && row.ID != null)
        .map((row) => String(row.ID)),
    );
    const top = [];
    const bottom = [];

    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      if (selectedIds.has(String(row?.ID))) {
        top.push(row);
      } else {
        bottom.push(row);
      }
    }

    return top.concat(bottom);
  };

  const getImportoListino = (accertamento) =>
    accertamento?.Importo ?? accertamento?.ImportoTarif ?? 0;

  const buildSelectedAccertamento = (protocolloAccertamento, allById) => {
    const listino = allById.get(String(protocolloAccertamento.Accertamenti));
    return {
      ...(listino || {}),
      ID: protocolloAccertamento.Accertamenti,
      Scadenza: protocolloAccertamento.Scadenza,
      Digiuno: protocolloAccertamento.Digiuno ?? listino?.Digiuno,
      Preventiva: protocolloAccertamento.Preventiva,
      Importo: getImportoListino(listino),
      ImportoPassivo: listino?.ImportoPassivo ?? 0,
    };
  };

  const stopEditingCellIfAny = useCallback(() => {
    const editingCells = Array.from(
      document.querySelectorAll(".MuiDataGrid-cell--editing"),
    );
    const api = null;

    // Prefer DataGrid internal edit model when available (v5 old editing API).
    const apiEditRows = api?.state?.editRows;
    if (apiEditRows && typeof apiEditRows === "object") {
      Object.keys(apiEditRows).forEach((rowId) => {
        const fieldsObj = apiEditRows[rowId] || {};
        Object.keys(fieldsObj).forEach((field) => {
          try {
            if (api?.commitCellChange) {
              api.commitCellChange({ id: rowId, field });
            }
            if (api?.setCellMode) {
              api.setCellMode(rowId, field, "view");
            }
            if (api?.stopCellEditMode) {
              api.stopCellEditMode({ id: rowId, field });
            }
          } catch (e) {
            console.error(e);
          }
        });
      });
    }

    if (!editingCells.length) {
      return;
    }

    const processed = new Set();
    for (let i = 0; i < editingCells.length; i++) {
      const editingCell = editingCells[i];
      const field = editingCell.getAttribute("data-field");
      const rowId = editingCell
        .closest(".MuiDataGrid-row")
        ?.getAttribute("data-id");
      const key = `${rowId ?? "no-id"}:${field ?? "no-field"}`;
      if (processed.has(key)) {
        continue;
      }
      processed.add(key);

      try {
        if (api?.stopCellEditMode && rowId != null && field) {
          api.stopCellEditMode({ id: rowId, field });
          continue;
        }

        if (api?.commitCellChange && rowId != null && field) {
          api.commitCellChange({ id: rowId, field });
          if (api?.setCellMode) {
            api.setCellMode(rowId, field, "view");
          }
        }
      } catch (e) {
        console.error(e);
      }

      const focusable = editingCell.querySelector(
        "input, textarea, [contenteditable='true']",
      );
      if (focusable?.blur) {
        focusable.blur();
      }
    }
  }, []);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handleGlobalPointerDown = (event) => {
      const editingCells = Array.from(
        document.querySelectorAll(".MuiDataGrid-cell--editing"),
      );
      if (!editingCells.length) {
        return;
      }

      const clickedInsideEditingCell = editingCells.some((cell) =>
        cell.contains(event.target),
      );
      if (clickedInsideEditingCell) {
        return;
      }

      stopEditingCellIfAny();
    };

    document.addEventListener("mousedown", handleGlobalPointerDown, true);
    return () => {
      document.removeEventListener("mousedown", handleGlobalPointerDown, true);
    };
  }, [open, stopEditingCellIfAny]);

  const columns = [
    {
      field: "Descrizione",
      headerName: "Accertamento",
      width: 300,
      renderCell: renderAccertamentoVisitaCell,
    },
    {
      field: "Scadenza",
      headerName: "Scadenza",
      type: "string",
      width: 150,
      editable: false,
      renderCell: (params) =>
        params.row.Scadenza
          ? moment(params.row.Scadenza).format("DD/MM/YYYY")
          : "",
    },
    {
      field: "Importo",
      headerName: "Importo €",
      type: "number",
      width: 120,
      editable: false,
      renderCell: (params) => (params.row.Importo ? params.row.Importo : 0),
    },
    {
      field: "ImportoPassivo",
      headerName: "Importo Passivo €",
      type: "number",
      width: 150,
      editable: false,
      renderCell: (params) =>
        params.row.ImportoPassivo ? params.row.ImportoPassivo : 0,
    },
  ];

  const loadVisitaLavoratore = async (val) => {
    let responseMedici = await unsplash.get("medici", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      params: { id: props.lavoratori[val].Cliente },
    });
    setMedici(responseMedici.data.data);

    let responseProtocollo = await unsplash.get("protocolloSanitario", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      params: { lavoratore: props.lavoratori[val].ID },
    });
    setProtocolliLav(responseProtocollo.data.data);
    let year = 0;
    if (props.lavoratori[val].CF) {
      year = ageFromCf(props.lavoratori[val].CF);
    }
    let d1 = new Date();
    let d2 = new Date(
      moment(d1.setDate(d1.getDate() + 60)).format("YYYY-MM-DD"),
    );

    let acs = responseProtocollo.data.data.filter(
      (p) =>
        p.Scadenza === null ||
        new Date(moment(p.Scadenza).format("YYYY-MM-DD")).getTime() <
          d2.getTime() ||
        p.Data === null,
    ); // solo accertamenti scaduti
    setSelectedACS(acs);

    let responseAccertamenti = await unsplash.get("accertamenti", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      params: { cliente: props.lavoratori[val].Cliente, ultimaVisita: 0 },
    });

    let allAccertamenti = responseAccertamenti.data.data;
    let arrayOnlyID = allAccertamenti.map((acc) => acc.ID);
    const isGavio =
      String(props.lavoratori[val].Categoria || "")
        .trim()
        .toLowerCase() === "gavio";

    for (let i = 0; i < acs.length; i++) {
      let index = arrayOnlyID.indexOf(acs[i].Accertamenti);
      if (index !== -1) {
        if (acs[i].Accertamenti === 42) {
          const scadenza = isGavio ? 24 : year > 50 ? 24 : 60;
          allAccertamenti[index].Scadenza = moment(dataSel)
            .add(scadenza, "M")
            .format("YYYY-MM-DD");
          acs[i].Scadenza = moment(dataSel)
            .add(scadenza, "M")
            .format("YYYY-MM-DD");
        } else if (
          props.lavoratori[val].Mansione === 631 &&
          acs[i].Accertamenti === 40
        ) {
          // La Visita Generale VDT mantiene la logica storica legata alla mansione 631.
          if (year > 50) {
            allAccertamenti[index].Scadenza = moment(dataSel)
              .add(24, "M")
              .format("YYYY-MM-DD");
            acs[i].Scadenza = moment(dataSel)
              .add(acs[i].Cadenze, "M")
              .format("YYYY-MM-DD");
          } else {
            allAccertamenti[index].Scadenza = moment(dataSel)
              .add(60, "M")
              .format("YYYY-MM-DD");
            acs[i].Scadenza = moment(dataSel)
              .add(acs[i].Cadenze, "M")
              .format("YYYY-MM-DD");
          }
        } else {
          allAccertamenti[index].Scadenza = moment(dataSel)
            .add(acs[i].Cadenze, "M")
            .format("YYYY-MM-DD");
          acs[i].Scadenza = moment(dataSel)
            .add(acs[i].Cadenze, "M")
            .format("YYYY-MM-DD");
        }
      }
    }

    //setSelectionModel(acs.map(acc => {return {ID:acc.Accertamenti}}))
    /* setSelectionModel(
      acs.map((acc) => {
        return { ID: acc.Accertamenti, Scadenza: acc.Scadenza };
      })
    ); */
    const allAccertamentiById = new Map(
      allAccertamenti.map((acc) => [String(acc.ID), acc]),
    );
    const selectionFromProtocollo = markProtocolloSanitarioPacchetti(
      acs.map((acc) => buildSelectedAccertamento(acc, allAccertamentiById)),
      allAccertamenti,
      acs,
    );
    let initialSelection =
      tipologiaSel !== 2
        ? selectionFromProtocollo.filter((acc) => acc.Preventiva === 0)
        : selectionFromProtocollo;
    setSelectionModel(initialSelection);
    setSelectionModelBk(selectionFromProtocollo);
    setAccertamenti(
      reorderAccertamentiBySelection(allAccertamenti, initialSelection),
    );
    setLoading(false);
  };

  const handleClickOpen = async () => {
    await setRequired({ medico: false, data: false, tipo: false });
    await loadVisitaLavoratore(0);
    setActiveStep(0);
    await setDataSel(new Date());
    setOpen(true);
    await setMedicoSel("");
    await setEsitoSel("");
    await setTipologiaSel("");
    await setNoteSel("");
    await setLuogoSel("");
  };
  const handleClose = () => {
    stopEditingCellIfAny();
    if (document.activeElement?.blur) {
      document.activeElement.blur();
    }
    setOpen(false);
    setTipologiaSel("");
  };
  const handleNext = async () => {
    //qua faccio le operazioni ogni volta
    let newSkipped = skipped;

    if (activeStep + 1 < props.lavoratori.length) {
      loadVisitaLavoratore(activeStep + 1);
    }
    await setRequired({ medico: false, data: false, tipo: false });
    //await setDataSel(new Date());
    //await setMedicoSel("");
    await setNoteSel("");
    //await setLuogoSel("");

    await setEsitoSel("");
    await setTipologiaSel("");
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
    /*if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    */
    //qui devo caricare con la query i dati
    if (activeStep === props.lavoratori.length - 1) {
      props.loadLavoratori();
    }
  };

  const handleDataChange = (event) => {
    let d = dataSel;
    setData(event); //.format("HH:mm")

    //utilizzo la forma abbreviata della condizione if (Guard clauses)
    if (event)
      return (d =
        moment(d).format("YYYY/MM/DD") + " " + event.format("HH:mm:ss"));
  };

  const handleSave = async () => {
    let req = { ...required };
    let checkOk = true; //lo uso per controllare che tutto sia ok
    if (medicoSel === "" || medicoSel === null) {
      req.medico = true;
      checkOk = false;
    } else {
      req.medico = false;
    }
    if (tipologiaSel === "" || tipologiaSel === null) {
      req.tipo = true;
      checkOk = false;
    } else {
      req.tipo = false;
    }

    if (dataSel === "" || dataSel === null) {
      req.data = true;
      checkOk = false;
    } else {
      req.data = false;
    }
    let d = moment(dataSel).format("YYYY-MM-DD");
    d = d + " " + (data ? data.format("HH:mm:ss") : "00:00:00");
    setRequired(req);
    if (checkOk) {
      try {
        let response = await unsplash.post(
          "visiteMediche",
          {
            accertamenti: selectionModel,
            medico: medicoSel,
            cliente: props.lavoratori[activeStep].Cliente,
            mansione: props.lavoratori[activeStep].Mansione,
            data: d,
            esito: esitoSel === "" ? null : esitoSel,
            luogo: luogoSel,
            note: noteSel,
            tipoVisita: tipologiaSel,
            lavoratore: props.lavoratori[activeStep].ID,
            distaccatoDa: props.lavoratori[activeStep].DistaccatoDa,
            vecchiaVisita: props.lavoratori[activeStep].IDUltimaVisita,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          },
        );
        setSnack({
          severity: "success",
          messaggio: "Visita Medica inserita con successo",
        });
        setOpenSnack(true);
        //setOpen(false);
      } catch {
        setSnack({
          severity: "error",
          messaggio: "Errore durante l'inserimento",
        });
        setOpenSnack(true);
        //setOpen(false);
      }
    }
  };

  const handleReorderCheck = async () => {
    setAccertamenti(
      reorderAccertamentiBySelection(accertamenti, selectionModel),
    );
    setLoading(false);
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <GridToolbarQuickFilter placeholder="Cerca..." />
          <Button
            size="small"
            onClick={() => handleReorderCheck()}
            startIcon={<CheckBox />}
          >
            Riordina
          </Button>
        </Grid>
      </GridToolbarContainer>
    );
  }

  const idsAccertamentiSelezionati = new Set(
    (selectionModel || [])
      .filter((sel) => sel && sel.ID != null)
      .map((sel) => sel.ID),
  );
  const accertamentiRaggruppati = buildAccertamentiVisitaRows(
    accertamenti,
    idsAccertamentiSelezionati,
    selectionModel,
  );
  const selectionModelGriglia = getAccertamentiVisitaSelectionRowIds(
    accertamentiRaggruppati,
    idsAccertamentiSelezionati,
  );

  return (
    <div>
      <GlobalSnackbar
        severity={snack.severity}
        messaggio={snack.messaggio}
        openSnack={openSnack}
        handleCloseSnack={handleCloseSnack}
      />
      <Button
        variant="outlined"
        sx={{ display: "none" }}
        onClick={handleClickOpen}
        id="myDialog"
      >
        Open form dialog
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="lg"
        TransitionComponent={Transition}
      >
        <DialogTitle>Visita Massiva</DialogTitle>
        <DialogContent>
          <Box sx={{ width: "100%" }}>
            <Stepper activeStep={activeStep}>
              {props.lavoratori.map((lav, index) => {
                const stepProps = {};
                const labelProps = {};
                stepProps.completed = false;
                //if (isStepSkipped(index)) {

                //}
                return (
                  <Step
                    key={lav.ID}
                    {...stepProps}
                    sx={{
                      display:
                        props.lavoratori[activeStep]?.ID === lav.ID
                          ? "Block"
                          : "None",
                    }}
                  >
                    <StepLabel {...labelProps}>
                      {lav.Cognome +
                        " " +
                        lav.Nome +
                        " - " +
                        lav.Descrizione}{" "}
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>
            {activeStep === props.lavoratori.length ? (
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1 }}>
                  Visita Massive completate!
                </Typography>
                {/*<Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Box sx={{ flex: '1 1 auto' }} />
            <Button onClick={handleReset}>ESCI</Button>
      </Box> pulsante esci al momento non ci serve*/}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      {required.tipo || required.data || required.medico ? (
                        <p style={{ color: "#FF2768" }}>
                          controlla i campi obbligatori!
                        </p>
                      ) : (
                        ""
                      )}
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth error={required.medico}>
                        <InputLabel id="demo-simple-select-label">
                          Medico
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={medicoSel}
                          label="Medico"
                          onChange={(e) => setMedicoSel(e.target.value)}
                        >
                          {medici?.map((medico) => (
                            <MenuItem key={medico.ID} value={medico.ID}>
                              {medico.Descrizione}
                            </MenuItem>
                          ))}
                        </Select>
                        {required.medico ? (
                          <FormHelperText>Medico obbligatorio</FormHelperText>
                        ) : null}
                      </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                      <LocalizationProvider dateAdapter={DateAdapter}>
                        <DatePicker
                          ampmInClock={false}
                          slotProps={{ textField: { error: required.data } }}
                          label="Data e ora"
                          value={moment(dataSel)}
                          onChange={(newValue) => {
                            setDataSel(newValue);
                            if (newValue) {
                              let allAccertamenti = accertamenti;
                              let arrayOnlyID = allAccertamenti.map(
                                (acc) => acc.ID,
                              );

                              let idProtocolli = selectedACS.map(
                                (s) => s.Accertamenti,
                              ); // prendo gli id nel protocollo
                              for (let i = 0; i < selectionModel.length; i++) {
                                let presente = idProtocolli.indexOf(
                                  selectionModel[i].ID,
                                );

                                let index = arrayOnlyID.indexOf(
                                  selectionModel[i].ID,
                                );

                                if (presente >= 0) {
                                  const months =
                                    selectionModel[i].ID === 42
                                      ? getVisiotestMonths(
                                          props.lavoratori[activeStep],
                                        )
                                      : selectedACS[presente].Cadenze;
                                  allAccertamenti[index].Scadenza = moment(
                                    newValue,
                                  )
                                    .add(months, "M")
                                    .format("YYYY-MM-DD");
                                  selectionModel[i].Scadenza = moment(newValue)
                                    .add(months, "M")
                                    .format("YYYY-MM-DD");
                                } else {
                                  allAccertamenti[index].Scadenza =
                                    moment(newValue).format("YYYY-MM-DD");
                                  selectionModel[i].Scadenza =
                                    moment(newValue).format("YYYY-MM-DD");
                                }
                              }
                              console.log(allAccertamenti);
                              setAccertamenti(allAccertamenti);
                            }
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={3}>
                      <LocalizationProvider dateAdapter={DateAdapter}>
                        <TimePicker
                          ampmInClock={false}
                          slotProps={{ textField: { fullWidth: true } }}
                          label="Ora"
                          value={moment(data)}
                          onChange={handleDataChange}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth error={required.tipo}>
                        <InputLabel id="demo-simple-select-label">
                          Tipologia Visita
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={tipologiaSel}
                          label="Tipologia Visita"
                          onChange={(e) => {
                            setTipologiaSel(e.target.value);
                            //se è preassuntiva
                            if (e.target.value !== 2) {
                              const idAccertamentiPreventiva = protocolliLav
                                ?.filter((prot) => prot.Preventiva === 1)
                                ?.map((el) => el?.Accertamenti);
                              const nextSelection = selectionModelBk?.filter(
                                (acc) =>
                                  !idAccertamentiPreventiva.includes(acc.ID),
                              );
                              setSelectionModel(nextSelection);
                              setAccertamenti((prev) =>
                                reorderAccertamentiBySelection(
                                  prev,
                                  nextSelection,
                                ),
                              );
                            } else {
                              setSelectionModel(selectionModelBk);
                              setAccertamenti((prev) =>
                                reorderAccertamentiBySelection(
                                  prev,
                                  selectionModelBk,
                                ),
                              );
                            }
                          }}
                          //onChange={(e) => setTipologiaSel(e.target.value)}
                        >
                          {props.tipologiaVisita?.map((tipologia) => (
                            <MenuItem key={tipologia.ID} value={tipologia.ID}>
                              {tipologia.Descrizione}
                            </MenuItem>
                          ))}
                        </Select>
                        {required.tipo ? (
                          <FormHelperText>
                            Tipologia obbligatoria
                          </FormHelperText>
                        ) : null}
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="Luogo"
                        multiline
                        value={luogoSel}
                        onChange={(e) => setLuogoSel(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <div
                        style={{ height: 400, width: "100%" }}
                        onMouseDownCapture={(event) => {
                          const editingCell = document.querySelector(
                            ".MuiDataGrid-cell--editing",
                          );
                          if (!editingCell) {
                            return;
                          }
                          if (!editingCell.contains(event.target)) {
                            stopEditingCellIfAny();
                          }
                        }}
                      >
                        <DataGridPro
                          components={{
                            Toolbar: CustomToolbar,
                            Footer: CustomFooterPersonalized,
                          }}
                          slots={{
                            loadingOverlay: LinearProgress,
                          }}
                          loading={loading}
                          disableSelectionOnClick
                          checkboxSelection
                          disableColumnMenu={true}
                          localeText={
                            itIT.components.MuiDataGrid.defaultProps.localeText
                          }
                          rows={accertamentiRaggruppati}
                          getRowId={getAccertamentiVisitaRowId}
                          columns={columns}
                          selectionModel={selectionModelGriglia}
                          onCellEditStart={() => {
                            isEditingCellRef.current = true;
                          }}
                          onCellEditStop={() => {
                            isEditingCellRef.current = false;
                          }}
                          onCellClick={(params, event) => {
                            if (params.field === "Scadenza") {
                              handleOpenScadenzaDialog(params.row);
                              return;
                            }
                            const editingCell = document.querySelector(
                              ".MuiDataGrid-cell--editing",
                            );
                            if (!editingCell) {
                              return;
                            }
                            const editingField =
                              editingCell.getAttribute("data-field");
                            const editingRowId =
                              editingCell.parentElement?.getAttribute(
                                "data-id",
                              );
                            const clickedSameCell =
                              String(editingRowId) === String(params.id) &&
                              editingField === params.field;

                            if (
                              !clickedSameCell &&
                              !editingCell.contains(event.target)
                            ) {
                              stopEditingCellIfAny();
                            }
                          }}
                          onSelectionModelChange={(ids) => {
                            if (isEditingCellRef.current) {
                              return;
                            }
                            // guardiamo solo cosa è stato aggiunto/tolto
                            // rispetto a prima, per non "promuovere" a piena
                            // selezione un gruppo solo parzialmente
                            // selezionato senza che l'utente lo tocchi
                            if (
                              (ids || []).length ===
                                selectionModelGriglia.length &&
                              (ids || [])
                                .map(String)
                                .every((id) =>
                                  selectionModelGriglia
                                    .map(String)
                                    .includes(id),
                                )
                            ) {
                              return;
                            }
                            const { aggiunti, rimossi } =
                              getAccertamentiVisitaSelectionChanges(
                                accertamentiRaggruppati,
                                ids,
                                selectionModelGriglia,
                              );
                            const {
                              nuovi: nuoviSelezionati,
                              selectedRows: selectedRowData,
                            } = getAccertamentiVisitaSelectedRows(
                              selectionModel,
                              accertamenti,
                              aggiunti,
                              rimossi,
                            );
                            //qua fai la magia con le date (solo sui nuovi)

                            let allAccertamenti = [...accertamenti];
                            let arrayOnlyID = allAccertamenti.map(
                              (acc) => acc.ID,
                            );

                            let idProtocolli = selectedACS.map(
                              (s) => s.Accertamenti,
                            ); // prendo gli id nel protocollo
                            for (let i = 0; i < nuoviSelezionati.length; i++) {
                              let presente = idProtocolli.indexOf(
                                nuoviSelezionati[i].ID,
                              );

                              let index = arrayOnlyID.indexOf(
                                nuoviSelezionati[i].ID,
                              );

                              if (presente >= 0) {
                                const months =
                                  nuoviSelezionati[i].ID === 42
                                    ? getVisiotestMonths(
                                        props.lavoratori[activeStep],
                                      )
                                    : selectedACS[presente].Cadenze;
                                allAccertamenti[index].Scadenza = moment(
                                  dataSel,
                                )
                                  .add(months, "M")
                                  .format("YYYY-MM-DD");
                              } else {
                                allAccertamenti[index].Scadenza =
                                  moment(dataSel).format("YYYY-MM-DD");
                              }
                            }
                            setAccertamenti(
                              reorderAccertamentiBySelection(
                                allAccertamenti,
                                selectedRowData,
                              ),
                            );

                            setSelectionModel(selectedRowData);
                            setSelectionModelBk((current) =>
                              getAccertamentiVisitaBackupSelection(
                                current,
                                selectedRowData,
                                protocolliLav,
                                tipologiaSel,
                              ),
                            );
                          }}
                          onCellEditCommit={(params) => {
                            const rowId = params?.id ?? params?.row?.ID;
                            if (rowId == null) {
                              return;
                            }

                            const gruppo = accertamentiRaggruppati.find(
                              (row) =>
                                String(getAccertamentiVisitaRowId(row)) ===
                                String(rowId),
                            );
                            const idsDaAggiornare = (
                              gruppo?._ids ?? [params?.row?.ID]
                            )
                              .filter((id) => id != null)
                              .map(String);
                            if (!idsDaAggiornare.length) {
                              return;
                            }

                            const idsDaAggiornareSet = new Set(idsDaAggiornare);

                            setAccertamenti((current) =>
                              current.map((row) =>
                                idsDaAggiornareSet.has(String(row.ID))
                                  ? { ...row, [params.field]: params.value }
                                  : row,
                              ),
                            );
                            setSelectionModel((current) =>
                              (current || []).map((row) =>
                                idsDaAggiornareSet.has(String(row.ID))
                                  ? { ...row, [params.field]: params.value }
                                  : row,
                              ),
                            );
                            setSelectionModelBk((current) =>
                              (current || []).map((row) =>
                                idsDaAggiornareSet.has(String(row.ID))
                                  ? { ...row, [params.field]: params.value }
                                  : row,
                              ),
                            );
                          }}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Esito
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={esitoSel}
                          label="Esito"
                          onChange={(e) => setEsitoSel(e.target.value)}

                          //onChange={handleChange}
                        >
                          {props.esiti?.map((esito) => (
                            <MenuItem key={esito.ID} value={esito.ID}>
                              {esito.Descrizione}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Note"
                        multiline
                        value={noteSel}
                        onChange={(e) => setNoteSel(e.target.value)}
                        sx={{ marginTop: "20px" }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </React.Fragment>
            )}
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            mt: 2,
            justifyContent: "space-between",
            px: 2,
          }}
        >
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Close />}
            onClick={handleClose}
            color="error"
          >
            Esci
          </Button>

          {/* <Button onClick={handleNext}>
              {activeStep === props.lavoratori.length - 1 ? "Fine" : "Avanti"}
            </Button> */}
          {activeStep === props.lavoratori.length - 1 ? (
            <Button
              variant="contained"
              className="ButtonMiller"
              startIcon={<DoneAll />}
              onClick={handleNext}
              color="success"
            >
              Fine
            </Button>
          ) : (
            <Button
              variant="contained"
              className="ButtonMiller"
              startIcon={<ArrowForward />}
              onClick={handleNext}
              color="success"
            >
              Avanti
            </Button>
          )}

          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Check />}
            onClick={handleSave}
            color="success"
          >
            Salva
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openScadenzaDialog}
        onClose={() => setOpenScadenzaDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Modifica Accertamento</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Descrizione"
                value={selectedAccertamento?.Descrizione || ""}
                disabled
              />
            </Grid>
            <Grid item xs={12}>
              <LocalizationProvider dateAdapter={DateAdapter}>
                <DatePicker
                  label="Scadenza"
                  value={
                    selectedAccertamento?.Scadenza
                      ? moment(selectedAccertamento.Scadenza, "YYYY-MM-DD")
                      : null
                  }
                  slotProps={{ textField: { fullWidth: true } }}
                  onChange={(newValue) =>
                    setSelectedAccertamento((current) => ({
                      ...current,
                      Scadenza: newValue
                        ? moment(newValue).format("YYYY-MM-DD")
                        : null,
                    }))
                  }
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setOpenScadenzaDialog(false)} color="error">
            Chiudi
          </Button>
          <Button onClick={handleSaveScadenzaDialog} variant="contained">
            Salva
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const ageFromCf = (cf) => {
  let mesi = {
    A: 0,
    B: 1,
    C: 2,
    D: 3,
    E: 4,
    H: 5,
    L: 6,
    M: 7,
    P: 8,
    R: 9,
    S: 10,
    T: 11,
  };

  let annoNascita = cf.substring(6, 8);
  let mese = mesi[cf.charAt(8)];
  let giornoNascita =
    parseInt(cf.substring(9, 11)) > 40
      ? parseInt(cf.substring(9, 11)) - 40
      : parseInt(cf.substring(9, 11));
  let yearTwoDigits = parseInt(new Date().getFullYear().toString().substr(-2));

  let year =
    yearTwoDigits > annoNascita
      ? 2000 + parseInt(annoNascita)
      : 1900 + parseInt(annoNascita);

  return calcAge(new Date(year, mese, giornoNascita));
  function calcAge(birthday) {
    birthday = new Date(birthday);
    let today = new Date();

    var years = today.getFullYear() - birthday.getFullYear();

    if (
      today.getMonth() < birthday.getMonth() ||
      (today.getMonth() == birthday.getMonth() &&
        today.getDate() < birthday.getDate())
    ) {
      years--;
    }

    return years;
  }
};
